import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectorHeadingProps = ComponentProps<"div">

function SelectorHeading(props: SelectorHeadingProps) {
  const { className, ...divProps } = props
  return <div className={cn("selector-heading", className)} {...divProps} />
}

export default SelectorHeading
